<!-- Mobile -->
<ng-container *transloco="let convert;">
  <div>
    <div class="edit-posting-mobile">
      @if (disableLinksForHold) {
        <div class="warning-wrapper">
          <div class="processing-banner">
            <em class="allycon-warning warning-icon"></em> {{convert('sellModule.posting.editPostingMobile.textVehiclePending')}}
          </div>
        </div>
      }
      <!--START VEHICLE INFORMATION-->
      <div class="edit-posting-mobile__header mt-3">{{convert('sellModule.posting.editPostingMobile.textVehicleInfo')}}</div>
      <accordion>
        <!--START BASIC INFORMATION-->
        <accordion-group panelClass="information-description" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Basic Information"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['information-description']"
            (click)="clickAccordion('information-description',editPostingForms.INFO_DESCRIPTION)"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="formNameSpan"
              [ngClass]="showErrorIcon(EditPostingFormNames.INFO_DESCRIPTION) ? 'ms-1 required-item-error-message' : 'ms-1' ">
              {{convert('sellModule.posting.editPostingMobile.textBasicInfo')}}
            </span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.INFO_DESCRIPTION)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.INFO_DESCRIPTION)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['information-description']) {
            <div class="form-wrapper">
              <app-description-form [postingTypeString]="postingTypeString"></app-description-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
        <!--START LOCATION-->
        <accordion-group panelClass="information-location" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Location"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['information-location']"
            (click)="clickAccordion('information-location',editPostingForms.INFO_LOCATION)"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="formNameSpan"
              [ngClass]="showErrorIcon(EditPostingFormNames.INFO_LOCATION) ? 'ms-1 required-item-error-message' : 'ms-1' ">
            {{convert('sellModule.posting.editPostingMobile.textLocation')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.INFO_LOCATION)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.INFO_LOCATION)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['information-location']) {
            <div class="form-wrapper">
              <app-location-form [postingTypeString]="postingTypeString"></app-location-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
      </accordion>
    </div>
    <div class="edit-posting-mobile">
      <!--START OPTIONS AND ACCESSORIES-->
      <div class="edit-posting-mobile__header">{{convert('sellModule.posting.editPostingMobile.textOptionAndAccessories')}}</div>
      <accordion>
        <!--START EXTERIOR-->
        <accordion-group panelClass="features-exterior" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Exterior"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['features-exterior']"
            (click)="clickAccordion('features-exterior',editPostingForms.OPTIONS_EXTERIOR)"
            [disabled]="disableLinksForHold">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="ms-1 formNameSpan">{{convert('sellModule.posting.editPostingMobile.textExterior')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.OPTIONS_EXTERIOR)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.OPTIONS_EXTERIOR)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['features-exterior']) {
            <div class="form-wrapper">
              <app-exterior-form [postingTypeString]="postingTypeString"></app-exterior-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
        <!--START INTERIOR-->
        <accordion-group panelClass="features-interior" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Interior"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['features-interior']"
            (click)="clickAccordion('features-interior',editPostingForms.OPTIONS_INTERIOR)"
            [disabled]="disableLinksForHold">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="ms-1 formNameSpan">{{convert('sellModule.posting.editPostingMobile.textInterior')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.OPTIONS_INTERIOR)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.OPTIONS_INTERIOR)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['features-interior']) {
            <div class="form-wrapper">
              <app-interior-form [postingTypeString]="postingTypeString"></app-interior-form>
            </div>
          }
          <app-edit-posting-buttons
          ></app-edit-posting-buttons>
        </accordion-group>
        <!--START MECHANICAL-->
        <accordion-group panelClass="features-mechanical" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Mechanical"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['features-mechanical']"
            (click)="clickAccordion('features-mechanical',editPostingForms.OPTIONS_MECHANICAL)"
            [disabled]="disableLinksForHold">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="ms-1 formNameSpan">{{convert('sellModule.posting.editPostingMobile.textMechanical')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.OPTIONS_MECHANICAL)) {
                <app-error-icon  [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.OPTIONS_MECHANICAL)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['features-mechanical']) {
            <div class="form-wrapper">
              <app-mechanical-form [postingTypeString]="postingTypeString"></app-mechanical-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
        <!--START FULL DESCRIPTION-->
        <accordion-group panelClass="features-full-description" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Full Description"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['features-full-description']"
            (click)="clickAccordion('features-full-description',editPostingForms.OPTIONS_ADDITIONAL)"
            [disabled]="disableLinksForHold">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="ms-1 formNameSpan">{{convert('sellModule.posting.editPostingMobile.textFullDescription')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.OPTIONS_ADDITIONAL)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.OPTIONS_ADDITIONAL)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['features-full-description']) {
            <div class="form-wrapper">
              <app-full-description-form [postingTypeString]="postingTypeString"></app-full-description-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
      </accordion>
    </div>
    <div class="edit-posting-mobile">
      <!--START VEHICLE IMAGES-->
      <div class="edit-posting-mobile__header">{{convert('sellModule.posting.editPostingMobile.textVehicleImage')}}</div>
      <accordion>
        <!--START PHOTOS-->
        <accordion-group panelClass="vehicle-photos" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Photos"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['vehicle-photos']"
            (click)="clickAccordion('vehicle-photos',editPostingForms.IMAGES_PHOTOS)"
            [disabled]="disableLinksForHold">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="ms-1 formNameSpan">{{convert('sellModule.posting.editPostingMobile.textPhotos')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.IMAGES_PHOTOS)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.IMAGES_PHOTOS)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['vehicle-photos']) {
            <div class="form-wrapper">
              <app-photos-form [postingTypeString]="postingTypeString"></app-photos-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
      </accordion>
    </div>
    <div class="edit-posting-mobile">
      <!--START VEHICLE DISCLOSURES-->
      <div class="edit-posting-mobile__header">{{convert('sellModule.posting.editPostingMobile.textVehicleDisclosures')}}</div>
      <accordion>
        <!--START CONDITION-->
        <accordion-group panelClass="vehicle-condition" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Condition"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['vehicle-condition']"
            (click)="clickAccordion('vehicle-condition',editPostingForms.DISCLOSURES_CONDITION)"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="ms-1 formNameSpan">{{convert('sellModule.posting.editPostingMobile.textCondition')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.DISCLOSURES_CONDITION)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.DISCLOSURES_CONDITION)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['vehicle-condition']) {
            <div class="form-wrapper">
              <app-condition-form
                (yellowLightEvent)="yellowLightSelected($event)"
                [postingTypeString]="postingTypeString">
              </app-condition-form>
            </div>
          }
          <app-edit-posting-buttons
            [isYellowLightChecked]="isYellowLightChecked"
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
        <!--START DAMAGES-->
        <accordion-group panelClass="vehicle-damages" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Damages"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['vehicle-damages']"
            (click)="clickAccordion('vehicle-damages',editPostingForms.DISCLOSURES_DAMAGES)"
            [disabled]="disableLinksForHold">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="ms-1 formNameSpan">{{convert('sellModule.posting.editPostingMobile.textDamages')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.DISCLOSURES_DAMAGES)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.DISCLOSURES_DAMAGES)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['vehicle-damages']) {
            <div class="form-wrapper">
              <app-damages-form [postingTypeString]="postingTypeString"></app-damages-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
        <!--START TIRES-->
        <accordion-group panelClass="vehicle-tires" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Tires"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['vehicle-tires']"
            (click)="clickAccordion('vehicle-tires',editPostingForms.DISCLOSURES_TIRES)"
            [disabled]="disableTires">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>

            <span class="formNameSpan"
              [ngClass]="showErrorIcon(EditPostingFormNames.DISCLOSURES_TIRES) ? 'ms-1 required-item-error-message' : 'ms-1' ">
            {{convert('sellModule.posting.editPostingMobile.textTires')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.DISCLOSURES_TIRES)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.DISCLOSURES_TIRES)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>

          </button>
          @if (accordionState['vehicle-tires']) {
            <div class="form-wrapper">
              <app-tires-form [postingTypeString]="postingTypeString"></app-tires-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
        <!--START ADDITIONAL-->
        <accordion-group panelClass="disclosure-additional" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Disclosure Details"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['disclosure-additional']"
            (click)="clickAccordion('disclosure-additional',editPostingForms.DISCLOSURES_ADDITIONAL)"
            [disabled]="disableLinksForHold">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="ms-1 formNameSpan">{{convert('sellModule.posting.editPostingMobile.textAdditional')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.DISCLOSURES_ADDITIONAL)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.DISCLOSURES_ADDITIONAL)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>
          </button>
          @if (accordionState['disclosure-additional']) {
            <div class="form-wrapper">
              <app-additional-disclosures-form [postingTypeString]="postingTypeString"></app-additional-disclosures-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
      </accordion>
    </div>
    <div class="edit-posting-mobile">
      <!--START VEHICLE PRICING-->
      <div class="edit-posting-mobile__header">{{convert('sellModule.posting.editPostingMobile.textVehiclePricing')}}</div>
      <accordion>
        <!--START PRICING AND FEES-->
        <accordion-group panelClass="vehicle-pricing-and-fees" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix edit-posting-mobile__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Pricing and Fees"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['vehicle-pricing-and-fees']"
            (click)="clickAccordion('vehicle-pricing-and-fees',editPostingForms.PRICING_PRICING_AND_FEES)">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>

            <span class="formNameSpan"
              [ngClass]="showErrorIcon(EditPostingFormNames.PRICING_PRICING_AND_FEES) ? 'ms-1 required-item-error-message' : 'ms-1' ">
            {{convert('sellModule.posting.editPostingMobile.textPricingFees')}}</span>
            <span class="iconSpan">
              @if (showErrorIcon(EditPostingFormNames.PRICING_PRICING_AND_FEES)) {
                <app-error-icon [remValue]="'1rem'" class="required-item-error-message">
                </app-error-icon>
              }
              @if (showSuccessIcon(EditPostingFormNames.PRICING_PRICING_AND_FEES)) {
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              }
            </span>

          </button>
          @if (accordionState['vehicle-pricing-and-fees']) {
            <div class="form-wrapper">
              <app-pricing-and-fees-form [postingTypeString]="postingTypeString"></app-pricing-and-fees-form>
            </div>
          }
          <app-edit-posting-buttons
            (continueSubmission)="continueSubmission.emit($event)"
          ></app-edit-posting-buttons>
        </accordion-group>
      </accordion>
    </div>
  </div>
</ng-container>
